import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const BodegaModalEditar = ({ show, onHide, data, setData, onSave }) => {
    // Manejar cambios en los inputs
    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave();
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header
                closeButton
                style={{ background: "linear-gradient(90deg, #ff9ccf 0%, #d63384 100%)", color: "white" }}
            >
                <Modal.Title>✏️ Editar Bodega</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control
                            type="text"
                            name="nombre"
                            value={data.nombre}
                            onChange={handleChange}
                            placeholder="Ingrese el nombre"
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Dirección</Form.Label>
                        <Form.Control
                            type="text"
                            name="direccion"
                            value={data.direccion}
                            onChange={handleChange}
                            placeholder="Ingrese la dirección"
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="puntoVentaCheck">
                        <Form.Check
                            type="checkbox"
                            label="¿Es punto de venta?"
                            checked={data.puntoVenta}
                            onChange={(e) =>
                                setData({ ...data, puntoVenta: e.target.checked })
                            }
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        ❌ Cancelar
                    </Button>
                    <Button
                        type="submit"
                        style={{ background: "linear-gradient(90deg, #ff9ccf 0%, #d63384 100%)", border: "none" }}
                    >
                        💾 Editar
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default BodegaModalEditar;